"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyBlock = PropertyBlock;
exports.PropertyBlockRow = PropertyBlockRow;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/PropertyBlock/index.tsx
// Figma: PropertyBlock — ガラス面のカードに「円形アイコン + ラベル + 値」の
// 行を積む共通部品。EventDetail のイベント概要と LotteryDetail の
// 受付期間 / 当落発表予定日 / 決済期間 で共用する。
//
// PropertyBlock     — ガラス面コンテナ (background.sub + backdrop-blur +
//                     shadow.cardGlass / radius.md)
// PropertyBlockRow  — 1 行。行間の境界線 border.neutral.default は
//                     最終行以外に引く (isLast で制御)。
//
// 値 (children) の描画は呼び出し側に委ねる。EventDetail の会場行のように
// 値そのものがリンクだったり副リンクを持つケースがあるため。
//
// 色・影は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function PropertyBlock(_a) {
    var children = _a.children;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            borderRadius: "".concat(tokens_1.radius.md, "px"),
            backgroundColor: p.background.sub,
            backdropFilter: "blur(".concat(tokens_1.blur.card, "px)"),
            WebkitBackdropFilter: "blur(".concat(tokens_1.blur.card, "px)"),
            boxShadow: p.shadow.cardGlass,
            overflow: 'hidden',
        }, children: children }));
}
function PropertyBlockRow(_a) {
    var icon = _a.icon, label = _a.label, _b = _a.labelWidth, labelWidth = _b === void 0 ? 80 : _b, _c = _a.labelVariant, labelVariant = _c === void 0 ? 'label' : _c, children = _a.children, height = _a.height, onClick = _a.onClick, _d = _a.isLast, isLast = _d === void 0 ? false : _d, _e = _a.layout, layout = _e === void 0 ? 'inline' : _e;
    var p = (0, theme_1.useV2Palette)();
    var labelStyle = labelVariant === 'body' ? tokens_1.textStyles.body : tokens_1.textStyles.label;
    var labelLineHeight = labelVariant === 'body' ? tokens_1.lineHeight.sm : tokens_1.lineHeight.xs;
    var labelNode = label !== undefined && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign(__assign({}, (layout === 'stacked' ? {} : { width: labelWidth, flexShrink: 0 })), labelStyle), { lineHeight: "".concat(labelLineHeight, "px"), color: p.foreground.neutral.secondary }), children: label }));
    // 縦積み: ラベルを上・値を下に積む (アイコンとラベル固定幅は使わない)
    if (layout === 'stacked') {
        return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { component: onClick ? material_1.ButtonBase : 'div', spacing: "".concat(tokens_1.spacing.xs, "px"), onClick: onClick, sx: {
                width: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
                alignItems: 'flex-start',
                p: "".concat(tokens_1.spacing.md, "px"),
                textAlign: 'left',
                borderBottom: isLast
                    ? 'none'
                    : "1px solid ".concat(p.border.neutral.default),
                cursor: onClick ? 'pointer' : 'default',
            }, children: [labelNode, (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { width: '100%', minWidth: 0 }, children: children })] }));
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { component: onClick ? material_1.ButtonBase : 'div', direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.sm, "px"), onClick: onClick, sx: __assign(__assign({ width: '100%', minWidth: 0, 
            // CssBaseline が無い環境 (Storybook 単体など) でも padding 分だけ
            // 親からはみ出さないように明示する
            boxSizing: 'border-box' }, (height
            ? { height: height, px: "".concat(tokens_1.spacing.md, "px") }
            : { p: "".concat(tokens_1.spacing.md, "px") })), { textAlign: 'left', justifyContent: 'flex-start', borderBottom: isLast ? 'none' : "1px solid ".concat(p.border.neutral.default), cursor: onClick ? 'pointer' : 'default' }), children: [icon && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    width: 32,
                    height: 32,
                    borderRadius: "".concat(tokens_1.radius.full, "px"),
                    backgroundColor: p.background.neutral.default,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    color: p.foreground.primary.main,
                    '& > *': { fontSize: 16 },
                }, children: icon })), labelNode, (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { flex: '1 1 0%', minWidth: 0 }, children: children })] }));
}
